// Mock data for user dashboard

export const userAccount = {
  name: "Alex Morgan",
  email: "alex.morgan@example.com",
  accountId: "BB-2847519",
  accountType: "Standard Live",
  currency: "USD",
  leverage: "1:500",
  balance: 24875.42,
  equity: 26193.18,
  margin: 1842.50,
  freeMargin: 24350.68,
  marginLevel: 1421.5,
  openPnL: 1317.76,
  dailyPnL: 482.19,
  totalPnL: 4193.18,
};

export const watchlist = [
  { symbol: "EURUSD", name: "Euro vs US Dollar", bid: 1.1612, ask: 1.1614, change: 0.12, spark: [1.158, 1.159, 1.160, 1.161, 1.1605, 1.1608, 1.1612, 1.1610, 1.1614, 1.1612] },
  { symbol: "GBPUSD", name: "Pound vs US Dollar", bid: 1.3402, ask: 1.3404, change: -0.08, spark: [1.343, 1.342, 1.341, 1.3405, 1.340, 1.3398, 1.340, 1.3402, 1.3400, 1.3402] },
  { symbol: "USDJPY", name: "US Dollar vs Yen", bid: 158.54, ask: 158.56, change: 0.05, spark: [158.3, 158.4, 158.5, 158.45, 158.52, 158.48, 158.5, 158.54, 158.52, 158.54] },
  { symbol: "XAUUSD", name: "Gold", bid: 4554.41, ask: 4554.68, change: 0.92, spark: [4510, 4520, 4515, 4530, 4540, 4535, 4545, 4550, 4548, 4554] },
  { symbol: "BTCUSD", name: "Bitcoin", bid: 80570, ask: 80595, change: 1.84, spark: [79100, 79400, 79800, 79600, 80100, 80300, 80200, 80400, 80500, 80570] },
  { symbol: "ETHUSD", name: "Ethereum", bid: 2256.7, ask: 2260.35, change: -0.45, spark: [2270, 2265, 2272, 2268, 2260, 2264, 2258, 2256, 2260, 2256] },
  { symbol: "US30", name: "Dow Jones 30", bid: 49685.87, ask: 49689.13, change: 0.21, spark: [49500, 49550, 49600, 49580, 49650, 49620, 49680, 49670, 49690, 49685] },
  { symbol: "NAS100", name: "Nasdaq 100", bid: 29146.59, ask: 29148.77, change: 0.66, spark: [28900, 28950, 29000, 28980, 29050, 29080, 29100, 29130, 29140, 29146] },
  { symbol: "TSLA", name: "Tesla Inc.", bid: 279.87, ask: 280.0, change: -1.15, spark: [283, 282, 281.5, 281, 280.5, 280.8, 280.2, 279.9, 280.1, 279.87] },
  { symbol: "AAPL", name: "Apple Inc.", bid: 192.46, ask: 192.47, change: 0.38, spark: [191.5, 191.8, 192, 192.1, 192.3, 192.2, 192.4, 192.35, 192.5, 192.46] },
];

export const openPositions = [
  {
    id: "#82451",
    symbol: "EURUSD",
    type: "BUY",
    volume: 1.5,
    openPrice: 1.1582,
    currentPrice: 1.1612,
    sl: 1.1550,
    tp: 1.1680,
    swap: -1.24,
    pnl: 450.0,
    openTime: "2026-05-14 09:32",
  },
  {
    id: "#82489",
    symbol: "XAUUSD",
    type: "BUY",
    volume: 0.5,
    openPrice: 4520.15,
    currentPrice: 4554.41,
    sl: 4480.00,
    tp: 4620.00,
    swap: -0.85,
    pnl: 1713.0,
    openTime: "2026-05-13 14:18",
  },
  {
    id: "#82512",
    symbol: "BTCUSD",
    type: "SELL",
    volume: 0.2,
    openPrice: 81200,
    currentPrice: 80595,
    sl: 82500,
    tp: 79000,
    swap: -2.10,
    pnl: 121.0,
    openTime: "2026-05-15 07:45",
  },
  {
    id: "#82534",
    symbol: "USDJPY",
    type: "SELL",
    volume: 1.0,
    openPrice: 158.20,
    currentPrice: 158.56,
    sl: 159.00,
    tp: 157.00,
    swap: 0.45,
    pnl: -227.0,
    openTime: "2026-05-15 10:12",
  },
  {
    id: "#82561",
    symbol: "TSLA",
    type: "BUY",
    volume: 10,
    openPrice: 282.5,
    currentPrice: 279.87,
    sl: 275.00,
    tp: 295.00,
    swap: 0,
    pnl: -26.3,
    openTime: "2026-05-15 11:30",
  },
];

export const tradeHistory = [
  { id: "#81203", symbol: "EURUSD", type: "BUY", volume: 1.0, open: 1.1520, close: 1.1582, pnl: 620.0, date: "2026-05-12" },
  { id: "#81189", symbol: "GBPUSD", type: "SELL", volume: 0.5, open: 1.3450, close: 1.3402, pnl: 240.0, date: "2026-05-11" },
  { id: "#81154", symbol: "XAUUSD", type: "BUY", volume: 0.3, open: 4485.00, close: 4520.00, pnl: 1050.0, date: "2026-05-10" },
  { id: "#81132", symbol: "ETHUSD", type: "BUY", volume: 1.0, open: 2280, close: 2258, pnl: -22.0, date: "2026-05-09" },
  { id: "#81098", symbol: "US30", type: "SELL", volume: 0.2, open: 49800, close: 49650, pnl: 300.0, date: "2026-05-08" },
  { id: "#81074", symbol: "NAS100", type: "BUY", volume: 0.5, open: 28900, close: 29100, pnl: 1000.0, date: "2026-05-07" },
  { id: "#81055", symbol: "AAPL", type: "BUY", volume: 5, open: 190.20, close: 192.00, pnl: 9.0, date: "2026-05-06" },
  { id: "#81022", symbol: "BTCUSD", type: "SELL", volume: 0.1, open: 82000, close: 81200, pnl: 80.0, date: "2026-05-05" },
];

export const transactions = [
  { id: "TX-2934", type: "Deposit", method: "Visa **** 4291", amount: 5000, status: "Completed", date: "2026-05-10" },
  { id: "TX-2901", type: "Withdrawal", method: "Bank transfer", amount: -1200, status: "Completed", date: "2026-05-05" },
  { id: "TX-2872", type: "Deposit", method: "Skrill", amount: 2500, status: "Completed", date: "2026-04-28" },
  { id: "TX-2845", type: "Deposit", method: "Visa **** 4291", amount: 10000, status: "Completed", date: "2026-04-15" },
  { id: "TX-2811", type: "Withdrawal", method: "Crypto (USDT)", amount: -800, status: "Pending", date: "2026-04-12" },
];

export const equityCurve = [
  20000, 20420, 20180, 20850, 21240, 20990, 21680, 22150, 21920, 22580,
  22340, 22980, 23250, 23080, 23690, 24120, 23890, 24580, 24380, 25040,
  24820, 25460, 25210, 25830, 25620, 26193,
];

export const sidebarNav = [
  { key: "overview", label: "Overview", icon: "layout" },
  { key: "trade", label: "Trade", icon: "candles" },
  { key: "copy-trading", label: "Copy", icon: "copy" },
  { key: "affiliate", label: "Affiliate", icon: "gift" },
  { key: "positions", label: "Positions", icon: "folder" },
  { key: "history", label: "History", icon: "clock" },
  { key: "deposits", label: "Funds", icon: "wallet" },
  { key: "reports", label: "Reports", icon: "file" },
  { key: "settings", label: "Settings", icon: "settings" },
];
